import { styled } from '@withjoy/joykit';
import { BOX_SHADOW_8_14_26 } from '@apps/card/constants/boxShadow';

/** `FitScaler`'s box: the frame the card is fitted into, and the query container it is sized against. */
export const FitFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  container-type: size;
`;

const CardBox = styled.div`
  aspect-ratio: var(--card-ratio);
  box-shadow: ${BOX_SHADOW_8_14_26};
  overflow: hidden;
`;

/**
 * The card fitted into `FitFrame` on both axes, as the gallery's static fallback does
 * (`FallbackCardBox`): `--card-ratio` is width / height, `--card-fit` is 0.8 for a square, as
 * `FitScaler` does. Below container-query support (Safari < 16) it fits along one axis, chosen
 * from the card's orientation.
 */
export const FitCardBox = styled(CardBox)`
  width: var(--card-fallback-width);
  height: var(--card-fallback-height);

  @supports (width: 1cqw) {
    width: calc(min(100cqw, 100cqh * var(--card-ratio)) * var(--card-fit));
    height: calc(min(100cqh, 100cqw / var(--card-ratio)) * var(--card-fit));
  }
`;

/** The card at the frame's full width, as `PageScaler` does. */
export const FullWidthCardBox = styled(CardBox)`
  width: 100%;
`;
